export const APP_URL =
  process.env.REACT_APP_API_URL || 'https://api-diary.namdao.dev/my-diary/v1';
